import React, { useEffect, useRef,useState  } from "react"
import { Container, Row, Col } from "react-bootstrap"
import "./TrustPilot.scss"

const TrustPilotWidget = () => {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    if (!scriptLoaded) {
      const script = document.createElement("script");
      script.src = "https://static.elfsight.com/platform/platform.js";
      script.async = true;
      script.onload = () => setScriptLoaded(true);
      document.body.appendChild(script);
    }
  }, [scriptLoaded]);

    return (
        <section className="trustpilot-reviews-widget customers-reviews pt-0">
            <Container>
                <Row>
                    <Col lg={12}>
            {scriptLoaded && (
              <>
                <div
                  className="elfsight-app-51812c8a-1400-4d34-9b6f-797e39801451"
                  data-elfsight-app-lazy
                ></div>
              </>
            )}
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default TrustPilotWidget;
